<script setup lang="ts">
import { KsDialogContent } from '@aschehoug/kloss-2'
</script>

<template>
  <KsDialogContent class="dialog-content">
    <slot />
  </KsDialogContent>
</template>

<style scoped lang="scss">
  .dialog-content {
    z-index: 1000;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90vw;
    max-width: $vgs-max-width-content;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 20px 40px 40px;
    background-color: var(--color-blue-50);
    color: var(--color-yellow-10);
    box-shadow: hsl(206deg 22% 7% / 35%) 0 10px 38px -10px, hsl(206deg 22% 7% / 20%) 0 10px 20px -15px;
    animation: content-show 250ms cubic-bezier(.16, 1, .3, 1);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;  /* For smooth scrolling on iOS */

    @include vgs-media-mobile {
      padding: 40px 16px;
      width: 100vw;
      max-height: 100dvh;
    }

    @include vgs-media-tablet {
      padding: 40px;
    }
  }

  @keyframes content-show {
    from {
      opacity: 0;
      transform: translate(-50%, -48%) scale(.96);
    }

    to {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }
</style>
